export const getPublicRequest = async (url) => {
  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    })

    if (!response.ok) {
      const text = await response.text()
      console.error('API ERROR:', text)
      throw new Error(`HTTP ${response.status}`)
    }

    const contentType = response.headers.get('content-type')

    if (!contentType || !contentType.includes('application/json')) {
      const text = await response.text()
      console.error('NOT JSON:', text)
      throw new Error('Invalid JSON response')
    }

    return await response.json()

  } catch (error) {
    console.error('PUBLIC GET ERROR:', error)
    throw error
  }
}